import { FIVE_MINUTES } from '@features/state/QueryClient/QueryClient';
import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaEntityWithDetailedTimeslots } from 'shared-types/Spa';
import { SPA_TIMESLOT_AVAILABILITY_TIMEOUT } from './consts';

export const getSpaFacilityTimeslotDetail = async (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  params: { arrivalDate: string; isTimeSlot: number }
) => {
  const { data } = await request.get(`${propertyId}/facilities/${spaFacilityId}/${language}`, {
    params,
    timeout: SPA_TIMESLOT_AVAILABILITY_TIMEOUT,
  });
  return data as SpaEntityWithDetailedTimeslots;
};

// the main use for this hook is to gain more information about an availability timeslot e.g. number available for multi-guest booking
export const useGetSpaFacilityTimeslotDetail = (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  arrivalDate: string
) => {
  const { data, isFetching } = useQuery({
    queryKey: getAvailableSpaFacilityTimeslotDetailKey(propertyId, language, spaFacilityId, {
      arrivalDate,
    }),
    queryFn: () =>
      getSpaFacilityTimeslotDetail(propertyId, language, spaFacilityId, {
        arrivalDate,
        isTimeSlot: 1,
      }),
    cacheTime: FIVE_MINUTES,
    staleTime: FIVE_MINUTES,
    keepPreviousData: true,
    enabled: !!arrivalDate,
  });
  return { data, isFetching };
};

export const getAvailableSpaFacilityTimeslotDetailKey = (
  propertyId: number,
  language: string,
  spaFacilityId: any,
  params: {
    arrivalDate: string | null;
  }
) => [
  'spaFacility',
  'timeslotDetail',
  propertyId,
  spaFacilityId,
  ...Object.values(params),
  language,
];
